var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 37C23.65 37 25 35.6615 25 34.0256H19C19 35.6615 20.335 37 22 37ZM31 28.0769V20.641C31 16.0754 28.54 12.2533 24.25 11.2421V10.2308C24.25 8.99641 23.245 8 22 8C20.755 8 19.75 8.99641 19.75 10.2308V11.2421C15.445 12.2533 13 16.0605 13 20.641V28.0769L10 31.0513V32.5385H34V31.0513L31 28.0769Z",
    fill: "#333D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.3c7921e8de88bbb2d22c6792ceadf434.svg";
export { ForwardRef as ReactComponent };